<!--
 * @description: 关于我们
 * @Author: Jay
 * @Date: 2021-09-17 10:44:27
 * @LastEditors: Jay
 * @LastEditTime: 2022-02-15 10:50:10
-->
<template>
  <div>
    <!-- 顶部 背景 标题 -->
    <bg-img-top
      :bgImg="$api + usData.image"
      EnTitle="About Us"
      title="关于我们"
      v-if="usData != ''"
    ></bg-img-top>
    <!-- <bg-img-top
      bgImg="https://scpic3.chinaz.net/Files/pic/pic9/202110/bpic24365_s.jpg"
      EnTitle="About Us"
      title="关于我们"
    ></bg-img-top> -->
    <!-- 边距 -->
    <div class="margin-top margin-bottom"></div>
    <!-- 公司介绍 -->
    <div class="introduce" :style="bgImage">
      <div class="fix-width">
        <div class="description">
          <div v-class="'animate__animated animate__fadeInUp'">
            <!-- <p class="description-des">
              是一家以智慧教育和开放平台为主体，在全球范围内服务公办教育，助力民办教育，探索未来教育新模式的科技教育公司。
              好未来的前身学而思成立于2003年，2010年在美国纽交所正式挂牌交易。好未来以“爱和科技让教育更美好”为使命，致力成为受尊敬的教育机构。
            </p>
            <p class="description-des wid2">
              是一家以智慧教育和开放平台为主体，在全球范围内服务公办教育，助力民办教育，探索未来教育新模式的科技教育公司。
              好未来的前身学而思成立于2003年，2010年在美国纽交所正式挂牌交易。好未来以“爱和科技让教育更美好”为使命，致力成为受尊敬的教育机构。
            </p> -->
            <p class="description-des wid3" v-html="content"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- 边距 -->
    <div class="margin-top margin-bottom"></div>
    <!-- 居中 -->
    <div class="fix-width">
      <!-- 总裁介绍 -->
      <left-picture
        :pictureData="usData.article[1]"
        v-if="usData != ''"
      ></left-picture>
      <!-- 边距 -->
      <div class="margin-top margin-bottom"></div>
      <!-- 品牌介绍标题 -->
      <div v-class="'animate__animated animate__fadeInUp'">
        <div class="padding text-align">
          <div class="font_size_xl font_weight_bold text-black">品牌故事</div>
          <div class="font_size_df margin-top-xs text-gary">brand story</div>
        </div>
      </div>
      <!-- 品牌介绍视频 -->
      <center-video
        :videoUrl="usData.brand_shipin"
        v-if="usData != ''"
      ></center-video>
    </div>
    <!-- 边距 -->
    <div class="margin-top margin-bottom"></div>
  </div>
</template>

<script>
// 顶部 背景 标题
import bgImgTop from "../../components/tab/bg-img-top.vue";
// 总裁介绍
import leftPicture from "../../components/code/left-picture.vue";
// 品牌介绍
import centerVideo from "../../components/video/center-video.vue";
import { aboutus } from "../../api/api";
export default {
  name: "AboutUs",
  data() {
    return {
      //公司介绍背景
      bgImage: "",
      //请求数据
      usData: [],
      //公司介绍
      content: "",
    };
  },
  components: {
    bgImgTop,
    leftPicture,
    centerVideo,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      //企业简介 关于我们
      aboutus().then((res) => {
        // console.log(res);
        this.usData = res.data;
        //公司介绍
        this.content = res.data.article[0].content;
        //公司介绍背景
        let img = this.$api + res.data.article[0].image;
        console.log(img);
        this.bgImage = {
          backgroundImage: "url(" + '"' + img + '"' + ")",
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//公司介绍背景
.introduce {
  padding: 74px 0 0;
  // background: url("../../assets/about-bg.png") no-repeat right bottom/760px;
  background-repeat: no-repeat;
  // background-position: right top;
  background-position: 69% top;
}
//公司介绍 宽
.description {
  width: 935px;
  padding-bottom: 105px;
}
//公司介绍 字
.description-des {
  display: inline-block;
  margin-bottom: 47px;
  line-height: 30px;
  font-size: 16px;
  color: #666666;
  word-break: break-all;
}
.wid2 {
  width: 855px;
}
.wid3 {
  width: 795px;
}
</style>